import EpisodeWatch from './EpisodeWatch';

export default EpisodeWatch;
